import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useParams } from 'react-router-dom';
import { AppShell } from '../app/AppShell';
import { ErrorBoundary } from '../app/ErrorBoundary';
import { NotFoundPage } from '../app/NotFoundPage';
import { paths } from '../app/paths';
import { AuthProvider } from '../features/auth/AuthProvider';
import { LoginPage } from '../features/auth/LoginPage';
import { RegisterPage } from '../features/auth/RegisterPage';
import { RequireAdmin } from '../features/auth/RequireAdmin';
import { UsersPage } from '../features/users/UsersPage';
import { CampaignReportPage } from '../features/reports/CampaignReportPage';
import { ReportsPage } from '../features/reports/ReportsPage';
import { RequireAuth } from '../features/auth/RequireAuth';
import { ApiSettingsPage } from '../features/settings/ApiSettingsPage';
import { ProjectDetailPage } from '../features/projects/ProjectDetailPage';
import { ProjectsPage } from '../features/projects/ProjectsPage';
import { TargetGroupWizard } from '../features/wizard/TargetGroupWizard';
import { ToastProvider } from '../ui';

/** Old bookmarks: /dashboard/ViewProject/:id -> /dashboard/projects/:id */
const LegacyProjectRedirect = () => {
  const { id } = useParams();
  return <Navigate to={paths.project(id)} replace />;
};

const MainLayout = () => (
  <ErrorBoundary>
  <ToastProvider>
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/dashboard" element={<RequireAuth />}>
            <Route element={<AppShell />}>
              <Route index element={<Navigate to="projects" replace />} />
              <Route path="projects" element={<ProjectsPage />} />
              <Route path="projects/:projectId" element={<ProjectDetailPage />} />
              <Route path="projects/:projectId/target-groups/:tgId/:step" element={<TargetGroupWizard />} />
              <Route path="reports" element={<ReportsPage />} />
              <Route path="reports/:projectId" element={<CampaignReportPage />} />
              <Route path="ApiSetting" element={<ApiSettingsPage />} />
              <Route path="users" element={<RequireAdmin><UsersPage /></RequireAdmin>} />
              <Route path="ProjectList" element={<Navigate to="projects" replace />} />
              <Route path="ViewProject/:id" element={<LegacyProjectRedirect />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Route>
          <Route path="*" element={<NotFoundPage standalone />} />
        </Routes>
      </AuthProvider>
    </Router>
  </ToastProvider>
  </ErrorBoundary>
);

export default MainLayout;
